const QC_STATUS_CHIP = {
  pending: "qc_pending",
  changes_requested: "qc_changes_requested",
  approved: "qc_approved",
  made_live: "made_live",
};

const QC_FILTER_OPTIONS = [
  { value: "pending", label: "QC pending" },
  { value: "changes_requested", label: "Changes requested" },
  { value: "approved", label: "QC approved" },
  { value: "made_live", label: "Sent to Launch" },
];

// used in AdRequest List page
const PRIORITIES_FILTER_OPTIONS = [
  {
    value: "low",
    label: "Low",
  },
  {
    value: "medium",
    label: "Medium",
  },
  {
    value: "high",
    label: "High",
  },
];

// Common filters options function all over tables
const handleStatusFilterOptions = ({ isOnRequestPage, isOnDeliveryPage }) => {
  const STATUS_FILTER_OPTIONS = [
    // filters required on AdDelivery Page
    ...(isOnDeliveryPage
      ? [
          { value: "delivery_pending", label: "Awaiting delivery" },
          { value: "pending", label: "Moderation pending" },
          { value: "moderation_approved", label: "Approved" },
          { value: "moderation_rejected", label: "Rejected" },
        ]
      : []),

    // Filters required in AdRequest Table
    ...(isOnRequestPage
      ? [
          { value: "pending", label: "Pending" },
          { value: "delivered", label: "Delivered" },
          { value: "delayed", label: "Delayed" },
          { value: "cancelled", label: "Cancelled" },
        ]
      : []),
  ];
  return STATUS_FILTER_OPTIONS;
};

export {
  QC_STATUS_CHIP,
  QC_FILTER_OPTIONS,
  PRIORITIES_FILTER_OPTIONS,
  handleStatusFilterOptions,
};
